module.exports = __webpack_public_path__ + "img/phoneEle.1b55874a.svg";